<template>
  <Modal
    :modal-style="{ width: '40vw', 'max-height': '100%' }"
    title="Manage Recipients"
  >
    <div
      key="form"
      class="q-pa-xs scroll column"
    >
      <EmailRecipientsInput
        v-model="spec.recipients"
        :organisation-id="spec.user.organisationId"
        validate-field
      />
    </div>

    <template #buttons>
      <QBtn
        aria-label="Done"
        class="no-shadow bg-primary bold q-py-smd text-white"
        label="Done"
        @click="save"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

import EmailRecipientsInput from "src/components/common/EmailRecipientsInput.vue";

export default {
  name: "EditScheduledReportSpecificationRecipientsModal",
  components: {
    EmailRecipientsInput,
    Modal,
  },
  props: {
    spec: {
      type: Object,
      required: true,
    },
  },
  emits: ["save"],
  methods: {
    save() {
      this.$emit("save", this.spec);
      this.close();
    },
    close() {
      this.$modals.close("EditScheduledReportSpecificationRecipientsModal");
    },
  },
};
</script>
